import { render } from "./TomarPedido.vue?vue&type=template&id=66351cfe&scoped=true"
import script from "./TomarPedido.vue?vue&type=script&lang=js"
export * from "./TomarPedido.vue?vue&type=script&lang=js"

import "./TomarPedido.vue?vue&type=style&index=0&id=66351cfe&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66351cfe"]])

export default __exports__